import axios, { AxiosRequestConfig } from 'axios'

function addLanguageHeaders(config: AxiosRequestConfig) {
  config.headers = {
    ...config.headers,
    'x-lang': 'ja'
  }
  return config
}

const v5External = axios.create({
  baseURL: process.env.REACT_APP_API_V5_EXTERNAL_URI
})
v5External.interceptors.request.use(addLanguageHeaders)

const v5Authorized = axios.create({
  baseURL: process.env.REACT_APP_API_V5_AUTHORIZED_URI
})
v5Authorized.interceptors.request.use(addLanguageHeaders)

const API = {
  /**
   * 認証情報をAPIクライアントに付加する
   * @param {{uuid: string accessToken: string}} param0 認証情報
   */
  init(uuid: string, accessToken: string) {
    v5Authorized.interceptors.request.use((config) => {
      config.headers = {
        ...config.headers,
        'uuid': uuid,
        'access-token': accessToken
      }
      return config
    })
  },
  v5External,
  v5Authorized
}

export default API
